module.exports = __webpack_public_path__ + "img/10.caa0b0bc.jpg";